var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirlcedPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 13.8335C4.77899 13.8335 2.16732 11.2218 2.16732 8.00016C2.16732 4.7785 4.77899 2.16683 8.00065 2.16683C11.2223 2.16683 13.834 4.7785 13.834 8.00016C13.834 11.2218 11.2223 13.8335 8.00065 13.8335ZM8.00065 14.6668C11.6825 14.6668 14.6673 11.6821 14.6673 8.00016C14.6673 4.31826 11.6825 1.3335 8.00065 1.3335C4.31875 1.3335 1.33398 4.31826 1.33398 8.00016C1.33398 11.6821 4.31875 14.6668 8.00065 14.6668Z",
    fill: "#112299"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 4.66683C8.23077 4.66683 8.41732 4.85338 8.41732 5.0835V7.5835H10.9173C11.1474 7.5835 11.334 7.77004 11.334 8.00016C11.334 8.23028 11.1474 8.41683 10.9173 8.41683H8.41732V10.9168C8.41732 11.1469 8.23077 11.3335 8.00065 11.3335C7.77053 11.3335 7.58398 11.1469 7.58398 10.9168V8.41683H5.08398C4.85387 8.41683 4.66732 8.23028 4.66732 8.00016C4.66732 7.77004 4.85387 7.5835 5.08398 7.5835H7.58398V5.0835C7.58398 4.85338 7.77053 4.66683 8.00065 4.66683Z",
    fill: "#112299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirlcedPlus);
export default __webpack_public_path__ + "static/media/cirlcedPlus.b222c967e9698ca8ebe3374b82b7ae49.svg";
export { ForwardRef as ReactComponent };